// @flow
import createMessages from 'mz-intl/create'

const MESSAGES = {
  SECURE_TITLE: '3D Secure',
  FIRST_NAME: 'First name',
  LAST_NAME: 'Last name',
  CARD_NUMBER: 'Card number',
  CARD_CVC: 'Card cvc',
  CARD_EXPIRY: 'Expires',
  CARD_DECLINED: 'Your card was declined',
  INCOMPLETE_NUMBER: 'Your card number is incomplete',
  INCOMPLETE_EXPIRY: "Your card's expiration date is incomplete",
  INCOMPLETE_CVC: "Your card's security code is incomplete",
  THREED_SECURE_CANCELED:
    'You canceled the authorization process. This trip cannot be booked without passing the authorization.',
  THREED_SECURE_DECLINED: 'The payment was declined. Please try again',
  THREED_SECURE_NOT_SUPPORTED:
    '3D Secure is not supported by your card. Please try another credit card',
  NOT_STRIPE_API_KEY: 'Stripe API key is not provided',
  MISSING_CARD_OR_CUSTOMER: 'No card or customer were provided',
  INIT_STRIPE_ERROR:
    'There was a problem in a process of initialization. Please try again. If the error will persist, please contact our support.',
  STRIPE_NOT_INITIALIZED: 'Stripe was not initialized',
  UNKNOWN_STRIPE_ERROR:
    'The following error occurred while processing your payment: {message} ({code}). Please contact our support if you think that it is inappropriate.',
  PAYMENT_METHOD_NOT_AVAILABLE:
    'Sorry, but selected payment method is not available. Please try to pay with any other available payment method.',
  PROCESSING_ERROR:
    'An unexpected error occurred preventing us from charging you with selected payment method. Please try to pay with another one.',
  RETRY_STRIPE_INIT: 'Try again',
  ALIPAY_METHOD_NAME: 'Alipay',
  ALIPAY_LIGHTBOX_TITLE: 'Alipay',
  CREDIT_CARD_METHOD: 'Credit Card',
  CURRENCY_SUPPORT_MESSAGE: 'Your payment will be processed in {currency}',
  CONFIRM_BOOKING: 'Book | {price}',
  TOTAL_PRICE: 'Total Price',
  SAVE_CERDIT_CARD: 'Securely Save Credit Card Information',
  ADD_NEW_CREDIT_CARD: 'Enter Credit Card Details',
  BOOK_WITH_ONE_CLICK: 'Pay With One Click',
  ALL_CREDIT_CARD_FIELDS_REQUIRED:
    'Please fill all credit card fields to be able to pay',
  SELECT_PAYMENT_METHOD: 'Please select a payment method',
  PAY_WITH_CERDIT_CARD: 'Or Pay With Credit Card',
  CARD_TITLE: 'Card',
  CARD_HOLDER_NAME: 'Name',
  EXPIRED: 'Expired',
  USE_EXISTING_CARD: 'Use credit card that was used previously',
  USE_PROVIDER_CARD: 'Bill changes to a provider',
  OPTIONS_INIT_ERROR:
    'There was an error initializing the options. Please try again. If the error will persist, please contact our support.',
  NO_OPTIONS_AVAILABLE: "We couldn't find any saved option",
  FREE_PAYMENT_ALLOWED:
    'Looks like your trip cost nothing. Enjoy your free ride!',
  BOOK_FOR_FREE: 'Book Now',
  PAY_WITH_APPLEPAY: 'Use Apple Pay',
  PAY_WTH_ALIPAY: 'Pay with Alipay',
  PAY_WITH_GOOGLEPAY: 'Use Google Pay',
  PAY_WITH_YOUR_BROWSER: 'Browser Stored Credit Card',
  DIRECT_BILL: 'Direct Bill',
  DIRECT_BILL_INFO:
    'Payment for this ride will be handled via Direct Bill with the provider',
  CANT_SAVE_3DS_REQUIRED_CARD:
    'This card requires additional secure check and can not be saved',
  DISABLED_CARDS_3DS_NOTICE:
    'Disabled cards do not support 3D Secure which is required to book this ride',
}

export default createMessages<typeof MESSAGES>(
  'UI_KIT_FORM_CREDIT_CARD_FIELD',
  MESSAGES
)
